import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_workers_allowed_access_toilets_restrooms_time'

export const dataPointDefinition = {
  retracedId: 'are_workers_allowed_access_toilets_restrooms_time',
  name: 'Are workers allowed access to toilets/restrooms at any time?',
  description: 'The intent of this question is to understand if workers have access to toilets/restrooms. ',
  meta: {
    slcpMeta: {
      key: 'hs-gen-10',
      number: 'HS-GEN-31',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-gen-10', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31180,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
